<template>
	<div class="list-document-common-actions">
		<o-button
			outline
			prefix-icon="download"
			color="info"
			@click="setup.documentService.downloadAsync(selected)">
			{{ $t('common.shared.components.listDocument.download') }}
		</o-button>

		<o-button
			v-tooltip="selected.length > 20 ? $t('common.shared.components.listDocument.maxDocuments') : undefined"
			outline
			prefix-icon="show"
			color="info"
			:disabled="selected.length > 20"
			@click="selected.length <= 20 ? setup.documentService.visualizeAsync(selected) : undefined">
			{{ $t('common.shared.components.listDocument.visualize') }}
		</o-button>

		<shared-tag-flat-select
			v-if="setup.self.can('TagLink')"
			v-tooltip="$t('common.shared.actions.assignTag')"
			:mapped-value="setup.mappedValue()"
			v-bind="{ linkType }"
			class="list-document-common-actions__tag-select"
			@add="setup.handleTagAdd($event as ITagLinkModel[])"
			@delete="setup.handleTagDelete($event as unknown as [number[]])">
			<o-button
				v-tooltip="selected.length > 20 ? $t('common.shared.components.listDocument.maxDocumentsTag') : undefined"
				outline
				prefix-font-icon="icon-interface-bookmark-tag"
				color="info"
				:disabled="selected.length > 20">
				{{ $t('common.shared.components.listDocument.tag') }}
			</o-button>
		</shared-tag-flat-select>

		<slot/>
	</div>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedListDocumentActionsEmits, SharedListDocumentActionsProps } from './SharedListDocumentActionsSetup';
import SharedListDocumentActionsSetup from './SharedListDocumentActionsSetup';
const emits = defineEmits<SharedListDocumentActionsEmits>() as SharedListDocumentActionsEmits;
const props = withDefaults(defineProps<SharedListDocumentActionsProps>(), SharedListDocumentActionsSetup.defaultProps);
const setup = new SharedListDocumentActionsSetup(props, emits);
// #endregion
</script>

<style lang="less" scoped>
@import "@/styles/variables";

.list-document-common-actions {
	display: flex;
	flex-wrap: wrap;

	&__tag-select {
		@media @layoutNavBottom {
			width: 100%;
		}
	}
}
</style>
